var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.06,
    height: 24.12,
    viewBox: "0 0 24.06 24.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#050606;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.06 0.12)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M24,18.43V24H18V21H15V18H12V15.57a7.88,7.88,0,0,1-1.82.7,8.32,8.32,0,0,1-4.12-.06,8.83,8.83,0,0,1-2-.83,8.56,8.56,0,0,1-3-3,8.83,8.83,0,0,1-.83-2A8.41,8.41,0,0,1,.23,6a8.83,8.83,0,0,1,.83-2,8.56,8.56,0,0,1,3-3,8.83,8.83,0,0,1,2-.83,8.41,8.41,0,0,1,4.38,0,8.83,8.83,0,0,1,2,.83,8.56,8.56,0,0,1,3,3,8.83,8.83,0,0,1,.83,2,8.33,8.33,0,0,1,.29,2.19,7.72,7.72,0,0,1-.09,1.18,10.7,10.7,0,0,1-.27,1.15Zm-1.5.64L14.41,11a9.48,9.48,0,0,0,.43-1.34A5.81,5.81,0,0,0,15,8.25a6.68,6.68,0,0,0-.53-2.63A6.85,6.85,0,0,0,10.88,2,6.781,6.781,0,0,0,2,10.88a6.85,6.85,0,0,0,3.59,3.59A6.68,6.68,0,0,0,8.25,15a6.59,6.59,0,0,0,2.23-.39,6.43,6.43,0,0,0,2-1.11h1v3h3v3h3v3h3ZM6,4.5a1.45,1.45,0,0,1,.59.12,1.5,1.5,0,1,1-1.18,0A1.45,1.45,0,0,1,6,4.5Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/Key.7afb8651.svg";
export { ForwardRef as ReactComponent };